import { Component } from '@angular/core';
import { CoreProductsBase } from 'src/app/col/utils/core-products-base';
import { LangProductMapper } from 'src/app/col/utils/lang-mappers';
import { SpinnerService } from 'src/app/utils/services/spinner.service';
import {StudentShoppingCartService} from "../../../../services/student-shopping-cart.service";
import { NativeServiceApiProvider } from '../../../../../services/native-api-provider.service';
import { ProductsUtilsV3 } from 'src/app/col/utils/v3/products-utils';

@Component({
    selector: 'app-spanish-products',
    templateUrl: './spanish-products.component.html',
    styleUrls: ['./spanish-products.component.scss'],
    standalone: false
})
export class SpanishProductsComponent extends CoreProductsBase {
  constructor(apiProvider: NativeServiceApiProvider,
              spinner: SpinnerService,
              shoppingCart: StudentShoppingCartService) {
    super(apiProvider, spinner, shoppingCart);
  }

  getLangName() {
    return LangProductMapper.mapLangCodeToLangName('sp');
  }
  getEbookCategoryLabel(): string {
    return 'category:ebook.sp';
  }
  getPaygCategoryLabel(): string {
    return 'category:lessons.sp.pag';
  }
  getIntensiveCategoryLabel(): string {
    return 'category:lessons.sp.int';
  }
  getStdCategoryLabel(): string {
    return 'category:lessons.sp.std';
  }
  getLightCategoryLabel(): string {
    return 'category:lessons.sp.light';
  }
  getProductsLabel(): string {
    return ProductsUtilsV3.SP_PRODUCT_LABEL;
  }
}
